import { withRedux } from './withRedux'
import { withRouter } from './withRouter'
import { compose } from 'ramda'

export const withProviders = compose(withRedux, withRouter)